import { useAuthMutation } from '@packages/shared/src/hooks/useAuthMutation/useAuthMutation';
import { DeleteProductFromOrderableBasketDocument } from '@packages/gql/generated/shopping/DeleteProductFromOrderableBasketDocument';

/* GraphQL */ `
  mutation DeleteProductFromOrderableBasket($locale: String!, $pli: String!) {
    deleteProductFromOrderableBasket(payload: { locale: $locale, pli: $pli }) {
      __typename
      ... on CheckoutChangedOrderableBasket {
        success
        orderableBasket {
          ...CheckoutOrderableBasketFragment
        }
      }
      ... on CheckoutServerFailure {
        failureMessage
      }
    }
  }
`;

export const useDeleteFromOrderableBasket = () =>
  useAuthMutation(DeleteProductFromOrderableBasketDocument);
